var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCovidHeadGraphicB(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 100",
    style: {
      enableBackground: "new 0 0 1080 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:none;stroke:#FFFFFF;stroke-width:0.25;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M453.6,65.4c8.3,0,15-6.7,15-15c0-8.3-6.7-15-15-15s-15,6.7-15,15C438.6,58.7,445.3,65.4,453.6,65.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M526.8,59.3c5,0,9-4,9-9s-4-9-9-9c-5,0-9,4-9,9C517.8,55.3,521.8,59.3,526.8,59.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M600,57.6c3.7,0,6.8-3.1,6.8-7s-3-7-6.8-7s-6.8,3.1-6.8,7S596.2,57.6,600,57.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M673.2,53.4c1.7,0,3-1.3,3-3s-1.3-3-3-3c-1.7,0-3,1.3-3,3S671.5,53.4,673.2,53.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M746.4,65.5c8.6,0,15.5-7,15.5-15.5c0-8.6-6.9-15.5-15.5-15.5s-15.5,7-15.5,15.5 C730.8,58.6,737.8,65.5,746.4,65.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M819.6,53.4c1.7,0,3-1.3,3-3s-1.3-3-3-3s-3,1.3-3,3S817.9,53.4,819.6,53.4"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 453.6,
    y1: 50.5,
    x2: 1080,
    y2: 50.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCovidHeadGraphicB);
export default __webpack_public_path__ + "static/media/COVID-HeadGraphicB.4825d0742b8dd6da281055c9e92aa866.svg";
export { ForwardRef as ReactComponent };